import { render, staticRenderFns } from "./Paint.vue?vue&type=template&id=04f5cc8c"
import script from "./Paint.vue?vue&type=script&lang=js"
export * from "./Paint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports